import { GoUnverified, GoVerified } from "react-icons/go";

const AlreadySigned = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen gap-4">
      <div className="flex flex-col items-center justify-center h-full gap-8">
        <GoVerified
          size={160}
          className="text-white bg-green-400 p-4 rounded-full"
        />
        <div className="text-3xl text-center font-semibold">
            Thank you for signing the agreement!
        </div>
        <div className="text-xl text-center">
            This document has already been signed.
        </div>
      </div>
    </div>
  );
};

export default AlreadySigned;
